// IntegratedContracts.jsx — 통합 계약 메뉴(contract) 화면 (2026-10-15, 4단계 계약 통합 4-5)
//   편집 창에서 고른 회사들의 계약을 한 화면에서 본다. 계약 관리 화면(ContractManagement) 한 벌을 그대로 쓰고
//   주소만 메뉴 주소(/api/admin/integrated-menus/{id}/contracts, 서버 integrated-contracts.route.js)로 바꾼다.
//   콜 없이 직접 등록하면 메뉴 회사 중 하나를 꼭 고른다(결정 1-a). 홍보물은 보기만(결정 2-a, 주문 넣기는 5단계).
//   목록에 회사 표시는 하지 않는다 — 통합 일일콜과 같다(3단계 결정 8).
//   key={menuId}: 계약 화면은 처음 한 번만 읽으므로, 같은 주소에서 메뉴를 바꿔 열면 새로 그리게 한다.
import React, { useMemo } from 'react';
import ContractManagement from './ContractManagement';
import { scopedContractApi } from './contractmanagement/contractApi';

export default function IntegratedContracts({ menuId, companyCodes }) {
  const codesKey = (Array.isArray(companyCodes) ? companyCodes : [])
    .map((c) => String(c || '').trim().toUpperCase()).filter(Boolean).join(',');
  const api = useMemo(
    () => scopedContractApi(`/api/admin/integrated-menus/${menuId}/contracts`, { companies: codesKey ? codesKey.split(',') : [] }),
    [menuId, codesKey],
  );
  return <ContractManagement key={menuId} api={api} />;
}
